import instanceAxios from '@/util/axios';
import { aiChatUrl } from '@/constants';
import { ChatTurn, CrmChatStreamEvent } from './chat.types';

/**
 * Streams the CRM chat response as NDJSON events. Uses fetch instead of the
 * shared axios instance because axios 0.27 cannot consume streaming responses
 * in the browser (same pattern as AiTextGeneretor).
 */
export const streamCrmChat = async (
  messages: ChatTurn[],
  onEvent: (event: CrmChatStreamEvent) => void,
  signal?: AbortSignal
): Promise<void> => {
  const response = await fetch(`${instanceAxios.defaults.baseURL}${aiChatUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') || ''
    },
    body: JSON.stringify({ messages }),
    signal
  });

  if (!response.ok || !response.body) {
    let message = 'שגיאה בשליחת ההודעה';
    try {
      const data = await response.json();
      message = data?.error || message;
    } catch {
      // Non-JSON error body — keep the generic message.
    }
    throw new Error(message);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const emitLine = (line: string) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    try {
      onEvent(JSON.parse(trimmed) as CrmChatStreamEvent);
    } catch {
      // Skip malformed lines (e.g. a partial line on connection drop).
    }
  };

  try {
    let reading = true;
    while (reading) {
      const { done, value } = await reader.read();
      if (done) {
        reading = false;
        break;
      }
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';
      lines.forEach(emitLine);
    }
    emitLine(buffer);
  } finally {
    reader.releaseLock();
  }
};
